import CodeBlockComponent from './CodeBlock';
import FormulaBlockComponent from './FormulaBlock';
import LatexFormulaBlockComponent from './LatexFormulaBlock';
import InlineCodeComponent from './InlineCode';
import BoldTextComponent from './BoldText';
import BracketTextComponent from './BracketText';
import HeadingComponent from './Heading';
import PlainTextComponent from './PlainText';

export const CodeBlock = CodeBlockComponent;
export const FormulaBlock = FormulaBlockComponent;
export const LatexFormulaBlock = LatexFormulaBlockComponent;
export const InlineCode = InlineCodeComponent;
export const BoldText = BoldTextComponent;
export const BracketText = BracketTextComponent;
export const Heading = HeadingComponent;
export const PlainText = PlainTextComponent;

// Also export format detection patterns
export const formatPatterns = {
  codeBlock: /^```[\w]*\s*[\s\S]*?```$/,
  formulaBlock: /^<FORMULA>[\s\S]*?<\/FORMULA>$/,
  latexFormula: /^\\\[\s*[\s\S]*?\\\]$/,
  inlineCode: /^`[^`]+`$/,
  boldText: /^\*\*[^*]+\*\*$/,
  heading: /^###\s?.+/,
  bracketText: /^\[[^\]]+\]$/
};

// Global regex to capture all format patterns
export const formatRegex = /(```[\w]*\s*[\s\S]*?```|<FORMULA>[\s\S]*?<\/FORMULA>|\\\[\s*[\s\S]*?\\\]|`[^`]+`|\*\*[^*]+\*\*|^###\s?.+|\[[^\]]+\])/gm;
